import { FC } from "react";
import LegendItem from "components/atoms/LegendItem";
import "styles/map-legends.scss";
import * as Icons from 'constants/icons';

const MapLegends: FC = () => {
  const data = [    
    {
      icon: Icons.F,
      label: "Service",
      name: "Service",
    },    
    {
      icon: Icons.IS,
      label: "Installation",
      name: "Installation",
    },
    {
      icon: Icons.KK,
      label: "Both",
      name: "Installation, Service",
    },
  ];
  return (
    <ul className="asr-legend">
      {data.map((legend) => (
        <li key={legend.label}>
          <LegendItem
            icon={legend.icon}
            label={legend.label}
            name={legend.name}
          />
        </li>
      ))}
    </ul>
  );
};

export default MapLegends;
